// useWatch.js
import { useEffect } from 'react'

export default function useWatch( callback, deps ) {
  useEffect(() => {
    callback();
  }, deps)
}